export default __webpack_public_path__ + "static/media/PF.4ec07505.ico";